import React, { useEffect, useMemo, useRef, useState } from "react";
import Select from "react-select";
import Switch from "react-switch";
import { generatePDF, onlyNumeric } from "../../commonClass/CommonValidation";
import { useNavigate } from "react-router-dom";
import { getAllData, postUsersData, verifytoken } from "../../../services/ApiCallingUserServices";
import { useDispatch, useSelector } from "react-redux";
import { loaderActions } from "../../../_actions/loader.actions";
import { ClearLocalStorage } from "../../commonClass/Session";
import { ExportExcel } from "../../commonClass/ExportExcel";
import { ConfirmationModal } from "../../../customControl/ConfirmationModal";
import CustomTable from "../../../customControl/CustomTable";
import CommonFilter from "../../../customControl/CommonFilter";

function Vehicalmaster() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [vehicleoptionId, setVehicleoptionId] = useState(1);
  const [vehicleoptionLabel, setVehicleoptionLabel] = useState({
    Name: "",
    exportName: ""
  });
  const [vehicleOption, setVehicleOption] = useState([])
  const [disableOption, setDisableOption] = useState(false)

  const [modalShow, setModalShow] = useState(false);
  const [activeId, setActiveId] = useState(false);
  const [btntxt, setBtnTxt] = useState("Add");
  const [editdisabled, setEditDisabled] = useState(true);
  const [disable, setDisable] = useState(false);
  const [fieldDisable, setFieldDisable] = useState(false);

  const [vehicleDataList, setVehicleDataList] = useState([]);
  const [filterList, setFilterList] = useState([]);

  const [selectCategoryOption, setSelectCategoryOption] = useState([])
  const [vehicleTypeOption, setVehicleTypeOption] = useState([])

  const [searchvalue, setSearchValue] = useState('');
  const [searchby, setSerachBy] = useState('All');
  const [searchDisabled, setSearchDisable] = useState(false);

  const [duplicateValue, setDuplicateValue] = useState();

  const user = useSelector((store) => store.userstatus.tba);
  const [useradd, setUserAdd] = useState(true);
  const [useredit, setUserEdit] = useState(true);
  const [userexport, setUserExport] = useState(true);

  const [formValue, setFormValue] = useState({
    VehicleDetailId: 0,
    VehicleName: "",
    VehicleCategoryId: 0,
    SeatingCapacity: 0,
    VehicleTypeId: 0,
    BaggageCapacity: 0,
    NoOfSeats: 0,
    IsActive: false,
  });
  const [formError, setFormError] = useState({});

  const [SelectCategoryId, setSelectCategoryId] = useState(0);
  const [VehicleTypeId, setVehicleTypeId] = useState(0);

  const selectCategoryId = useRef();
  const vehicleTypeId = useRef();
  const selectTypeId = useRef();


  const getvehicleheaderlist = async () => {
    await getAllData('/master/v1/getvehicleheaderlist')?.then(response => {
      if (response?.status) {
        setVehicleOption(response?.data);
        response?.data?.map((obj) => {
          obj.exportlabel = obj?.label?.split(" ")?.filter((fil) => fil !== "-")?.join(" ")?.replace(/[\*\?:\\\/\[\]]/g, "_");
          return obj;
        })
        const defaultSelected = response?.data?.find((fin) => fin?.value === vehicleoptionId)?.label;
        setVehicleoptionLabel((opt) => ({ ...opt, Name: defaultSelected?.exportlabel, exportName: defaultSelected?.exportlabel }))
      }
    })
  }

  const handleVehicleOptionChange = (e) => {
    setVehicleoptionId(e?.value);
    setVehicleoptionLabel((opt) => ({ ...opt, Name: e?.exportlabel, exportName: e?.exportlabel }))
  };


  // Getting Vehicle Data from API--------------------------------------------------------------

  const getvehiclelistdetails = async (id) => {
    const VehicleData = await getAllData(`/master/v1/getvehiclelistdetails?VehicleHeaderId=${id}`);
    if (VehicleData?.status) {
      VehicleData?.data?.map((obj) => {
        obj.Active = obj?.IsActive ? "Active" : "InActive"
        obj.CreatedOnFormat = formatDate(obj?.CreatedOn)
        return obj;
      })
      setVehicleDataList(VehicleData?.data ? VehicleData?.data : []);
      setFilterList(VehicleData?.data ? VehicleData?.data : []);
    }
    else {
      setVehicleDataList([]);
      setFilterList([]);
    }
  };

  // Getting Vehicle Data from API--------------------------------------------------------------

  //#region On Change Methods
  const handleChange = (name, value) => {
    setFormError({});
    setDuplicateValue("");
    setEditDisabled(true);
    setFormValue((form) => ({ ...form, [name]: value }));
  };


  const getvehiclecategorylist = async () => {
    await getAllData('/master/v1/getvehiclecategorylist').then(response => {
      if (response?.status) {
        setSelectCategoryOption(response?.data)
      }
    })
  }

  const vehicleCategories = useMemo(() => {
    return selectCategoryOption?.filter((fil) => fil?.VehicleHeaderId === vehicleoptionId);
  }, [selectCategoryOption, vehicleoptionId])


  const handleSelectCategoryChange = (e) => {
    setFormError({});
    setDuplicateValue("");
    setEditDisabled(true);
    setSelectCategoryId(e.value);
    setFormValue((form) => ({ ...form, VehicleCategoryId: e.value }));
  };


  const getvehicletypelist = async () => {
    await getAllData('/master/v1/getvehicletypelist').then(response => {
      if (response?.status) {
        setVehicleTypeOption(response?.data)
      }
    })
  }
  const handleVehicleTypeChange = (e) => {
    setFormError({});
    setDuplicateValue("");
    setEditDisabled(true);
    setVehicleTypeId(e.value);
    setFormValue((form) => ({ ...form, VehicleTypeId: e.value }));
  };

  const handleisActive = (e) => {
    if (btntxt === "Add") {
      setFormValue((form) => ({ ...form, IsActive: !activeId }));
      setActiveId(!activeId);
      setFormError({});
      setDuplicateValue("");
    } else {
      setModalShow(true);
    }
  };

  const handleConfirmation = (e) => {
    //setYesNoConfirm(e)
    if (e === true) {
      setFormValue((form) => ({ ...form, IsActive: !activeId }));
      setActiveId(!activeId);
      setEditDisabled(true);
      setFormError({});
      setDuplicateValue("");
    }
    setModalShow(false);
  };
  //#endregion

  //#region validations
  const validation = () => {
    let status = true;
    let error = {};

    if (formValue?.VehicleName?.trim()?.length === 0) {
      error.VehicleName = "Kindly enter the Vehicle Name";
      status = false;
    }
    if (vehicleoptionId !== 2 && SelectCategoryId === 0) {
      error.selectCategoryId = "Kindly select Vehicle Category";
      status = false;
    }
    if (vehicleoptionId !== 2 && (formValue.SeatingCapacity?.length === 0 || formValue.SeatingCapacity === 0)) {
      error.SeatingCapacity = "Kindly enter the Seating Capacity";
      status = false;
    }
    if (VehicleTypeId === 0) {
      error.vehicleTypeId = vehicleoptionId === 2 ? "Kindly Select Type" : "Kindly select Vehicle Type";
      status = false;
    }
    if (vehicleoptionId === 2 && (formValue.NoOfSeats?.length === 0 || formValue.NoOfSeats === 0)) {
      error.NoOfSeats = 'Kindly enter the No. Of Seats'
      status = false;
    }

    setFormError(error);
    if (Object.keys(error)?.length > 0) {
      let id = Object.keys(error)[0];
      if (id === "selectCategoryId") {
        selectCategoryId.current.focus();
      }
      if (id === "vehicleTypeId") {
        vehicleTypeId.current.focus();
      }
      if (id === "selectTypeId") {
        selectTypeId.current.focus();
      }
      else {
        document.getElementById(id)?.focus();
      }
    }

    return status;
  };
  //#endregion

  const checkDuplicateError = () => {
    let status = true;
    let error = {};

    const checkDuplicate = vehicleDataList?.filter((fil) => fil?.VehicleDetailId !== formValue?.VehicleDetailId && fil?.VehicleName?.trim() === formValue?.VehicleName?.trim())?.length
    if (checkDuplicate > 0) {
      error.Duplicate = 'You can not enter duplicate value.'
      status = false;
    }
    setFormError(error);
    return status;
  }

  //#region Add/Update Data
  const handleAdd = async (e) => {
    e.preventDefault();
    if (validation() && checkDuplicateError()) {
      let statusoftoken = await verifytoken();
      if (statusoftoken) {
        setDisable(true);
        setEditDisabled(false);
        const data = vehicleoptionId === 2 ?
          {
            VehicleHeaderId: vehicleoptionId,
            VehicleDetailId: formValue?.VehicleDetailId,
            VehicleName: formValue?.VehicleName?.trim(),
            VehicleTypeId: formValue?.VehicleTypeId,
            NoOfSeats: formValue?.NoOfSeats,
            IsActive: formValue?.IsActive,
          }
          :
          {
            VehicleHeaderId: vehicleoptionId,
            VehicleDetailId: formValue?.VehicleDetailId,
            VehicleName: formValue?.VehicleName?.trim(),
            VehicleCategoryId: formValue?.VehicleCategoryId,
            SeatingCapacity: formValue?.SeatingCapacity,
            VehicleTypeId: formValue?.VehicleTypeId,
            BaggageCapacity: formValue?.BaggageCapacity,
            IsActive: formValue?.IsActive,
          }
        const VehicleData = await postUsersData("/master/v1/insertorupdatevehicledetails", data);
        if (VehicleData.status) {
          getvehiclelistdetails(vehicleoptionId);
          dispatch({ type: 'ALERTING', message: VehicleData.message })
          clear();
        }
        else {
          dispatch({ type: 'ALERTING', message: VehicleData.message })
          return;
        }
      }
      else {
        ClearLocalStorage();
        dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
      }
    }
  };

  //#endregion

  //#region Clear Data
  const handleClear = (e) => {
    clear();
  };

  function clear() {
    setSearchDisable(false)
    setDisableOption(false)
    setFormValue({
      ...formValue,
      VehicleName: "",
      VehicleDetailId: 0,
      VehicleCategoryId: 0,
      SeatingCapacity: 0,
      VehicleTypeId: 0,
      BaggageCapacity: 0,
      NoOfSeats: 0,
      IsActive: false,
    });
    setSelectCategoryId(0)
    setVehicleTypeId(0)
    setFormError({});
    setDuplicateValue("");
    setActiveId(false);
    getvehiclelistdetails(vehicleoptionId);
    setBtnTxt("Add");
    setEditDisabled(true);
    setDisable(false);
    setFieldDisable(false);
    setSearchValue("");
    setSerachBy("All");
  }
  //#endregion

  //Columns
  const columns = [
    {
      name: vehicleoptionId === 2 ? "Bus Name" : "Vehicle Name",
      key: "VehicleName",
      sortable: true,
      float: "left",
      selector: (row) => row?.VehicleName,
    },
    {
      name: "Vehicle Category",
      key: "VehicleCategory",
      sortable: true,
      float: "left",
      selector: (row) => row?.VehicleCategory,
      omit: vehicleoptionId === 2 ? true : false
    },
    {
      name: "Seating Capacity",
      key: "SeatingCapacity",
      sortable: true,
      float: "left",
      selector: (row) => row?.SeatingCapacity,
      omit: vehicleoptionId === 2 ? true : false
    },
    {
      name: vehicleoptionId === 2 ? "Select Type" : "Vehicle Type",
      key: "VehicleType",
      sortable: true,
      float: "left",
      selector: (row) => row?.VehicleType,
    },
    {
      name: "Baggage Capacity",
      key: "BaggageCapacity",
      sortable: true,
      float: "left",
      selector: (row) => row?.BaggageCapacity,
      omit: vehicleoptionId === 2 ? true : false
    },
    {
      name: "No. Of Seats",
      key: "NoOfSeats",
      sortable: true,
      float: "left",
      selector: (row) => row?.NoOfSeats,
      omit: vehicleoptionId !== 2 ? true : false
    },
    {
      name: "Active",
      key: "Active",
      sortable: true,
      float: "left",
      selector: (row) => row.Active,
    },
    {
      name: "Create Date",
      sortable: true,
      float: "left",
      selector: (row) => new Date(row.CreatedOn),
      format: (row) => row.CreatedOnFormat,
    },
    {
      name: "Edit",
      selector: (row) => (<button type="button" className="border-0 p-0 bg-body set_disableclr" disabled={!useredit}><i className="fa fa-edit" onClick={() => handleEditView("Edit", row?.VehicleDetailId)}></i></button>),
    },
    {
      name: "View",
      selector: (row) => (<i className="fa fa-eye" onClick={() => handleEditView("View", row.VehicleDetailId)}></i>),
    },
  ];

  const handleEditView = (type, id) => {
    setSearchDisable(true)
    setDisableOption(true)
    setDisable(true);
    setFieldDisable(type === "Edit" ? false : true);
    setEditDisabled(false);
    setBtnTxt(type === "Edit" ? "Update" : "Add");
    RetriveData(id);
  }

  const RetriveData = async (id) => {
    const VehicleDataEditDetail = await getAllData('/master/v1/getvehicledetailsbyid?VehicleDetailId=' + id)
    setFormError({});
    setDuplicateValue("");
    VehicleDataEditDetail?.data?.filter((fil) => fil.VehicleDetailId === id)?.map((obj) => {
      setFormValue((form) => ({
        ...form,
        VehicleName: obj?.VehicleName,
        VehicleCategoryId: obj?.VehicleCategoryId,
        VehicleDetailId: obj?.VehicleDetailId,
        SeatingCapacity: obj?.SeatingCapacity,
        VehicleTypeId: obj?.VehicleTypeId,
        BaggageCapacity: obj?.BaggageCapacity,
        NoOfSeats: obj?.NoOfSeats,
        IsActive: obj?.IsActive,
      }))
      setActiveId(obj?.IsActive);
      setSelectCategoryId(obj?.VehicleCategoryId);
      setVehicleTypeId(obj?.VehicleTypeId);
    });
  }

  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [day, month, year].join("/");
  }
  //#endregion

  //#region Exports
  const PDFExport = () => {
    const keys = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.key);
    const pdfColumns = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.name);
    const rows = vehicleDataList?.map((obj) => keys?.map((key) => obj[key]))
    generatePDF(pdfColumns, rows, vehicleoptionLabel?.exportName, vehicleoptionLabel?.exportName)
  };

  const ExcelExport = () => {
    const dispalyname = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.name);
    const fields = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.key);
    ExportExcel(dispalyname, fields, vehicleDataList, vehicleoptionLabel?.exportName, `${vehicleoptionLabel?.exportName}.xls`);
  };
  //#endregion

  //#region UseEffect
  useEffect(() => {

    async function fetchData() {
      dispatch(loaderActions.start());
      const statusoftoken = await verifytoken();
      if (statusoftoken) {
        setFormError({});
        setDuplicateValue("");
        setSearchValue("");
        setSerachBy("All");
        getvehiclelistdetails(vehicleoptionId)
        dispatch(loaderActions.end());
      }
      else {
        ClearLocalStorage();
        dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        dispatch(loaderActions.end());
      }
    }

    fetchData();
  }, [vehicleoptionId]);

  useEffect(() => {
    async function fetchData() {
      const statusoftoken = await verifytoken();
      if (statusoftoken) {
        Promise.all([
          getvehicleheaderlist(),
          getvehiclecategorylist(),
          getvehicletypelist()
        ]).then().catch((error) => console.error(error))
      }
      else {
        ClearLocalStorage();
        dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        dispatch(loaderActions.end());
      }
    }
    fetchData();
  }, [])


  useEffect(() => {
    // let MENUID = GetMenuIdFromStorage()
    // let viewrights = false;
    // user?.filter(x => x.MenuId === MENUID).map((obj) => {
    //   viewrights = obj.URightView;
    //   setUserAdd(obj.URightAdd);
    //   setUserEdit(obj.URightEdit);
    //   setUserExport(obj.URightExport);
    //   if (!viewrights) {
    //     navigate('/dashboard');
    // }
    // });
    // let MENUID = GetMenuIdFromStorage();
    let pagelink = user?.find(x => {
      if (x.PageLink === window.location.pathname)
        return x.MenuId
    });
    let mid = user?.find((x) => x.MenuId === pagelink.MenuId);
    if (mid?.URightView === false && mid?.URightView !== undefined) {
      navigate("/dashboard");
    }
    user?.filter((x) => x.MenuId === pagelink.MenuId).map((obj) => {
      setUserAdd(obj.URightAdd);
      setUserEdit(obj.URightEdit);
      setUserExport(obj.URightExport);
    });
  }, [user]);
  //#endregion

  return (
    <>
      <div className="container-fluid mt-4 heading_color">
        <h3>Vehicle Master</h3>
      </div>
      <div className="container-fluid form_border py-5 mb-3">
        <div className="row my-3 mx-1">
          <div className="col-lg-3 col-md-6 col-sm-6 col-12">
            <Select
              className="select_dropdown dropdown"
              options={vehicleOption}
              // defaultValue={vehicleOption[0]}
              value={vehicleOption?.filter(function (vehicleoption) {
                return vehicleoption.value === vehicleoptionId;
              })}
              onChange={(e) => handleVehicleOptionChange(e)}
              isDisabled={disableOption}
            />
          </div>
        </div>

        <div className="mb-3 mt-5">
          <form action="">
            <div className="mb-3 row mx-1">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="row">
                  {formError?.Duplicate && (<div className="text-danger pb-3 text-center"> {formError?.Duplicate} </div>)}

                  {
                    vehicleoptionId === 2 ?
                      <>
                        <div className='col-lg-6 col-sm-6 '>
                          <div className='row'>
                            <div className="col-lg-4 col-md-12 mb-1">
                              <label className="col-form-label required" htmlFor="VehicleName">Bus Name</label>
                            </div>
                            <div className="col-lg-8 mb-1 col-md-12">
                              <input
                                className="form-control"
                                type="text"
                                id="VehicleName"
                                name="VehicleName"
                                value={formValue.VehicleName}
                                onChange={(e) => handleChange(e.target.name, e.target.value)}
                                placeholder="Bus Name"
                                maxLength={200}
                                disabled={fieldDisable ? true : false}
                              />
                              {formError.VehicleName && (<div className="text-danger"> {formError.VehicleName} </div>)}
                            </div>
                          </div>
                        </div>

                        <div className='col-lg-6 col-sm-6 '>
                          <div className='row'>
                            <div className="col-lg-4 col-md-12 mb-1">
                              <label className="col-form-label required">Select Type</label>
                            </div>
                            <div className="col-lg-8 mb-1 col-md-12">
                              <Select
                                ref={selectTypeId}
                                id="StateId"
                                className="dropdown select_dropdown"
                                options={vehicleTypeOption}
                                value={vehicleTypeOption?.filter(function (types) {
                                  return types.value === VehicleTypeId;
                                })}
                                onChange={(e) => handleVehicleTypeChange(e)}
                                isDisabled={fieldDisable ? true : false}
                                isSearchable
                              />
                              {formError.vehicleTypeId && (<div className="text-danger">{formError.vehicleTypeId}</div>)}
                            </div>
                          </div>
                        </div>

                        <div className='col-lg-6 col-sm-6 '>
                          <div className='row'>
                            <div className="col-lg-4 col-md-12 mb-1">
                              <label className="col-form-label required" htmlFor="NoOfSeats">No. Of Seats</label>
                            </div>
                            <div className="col-lg-8 mb-1 col-md-12">
                              <input
                                className="form-control"
                                type="text"
                                id="NoOfSeats"
                                name="NoOfSeats"
                                value={formValue.NoOfSeats === 0 ? '' : formValue.NoOfSeats}
                                onChange={(e) => handleChange(e.target.name, Number(onlyNumeric(e.target.value)))}
                                placeholder="No. Of Seats"
                                maxLength={3}
                                disabled={fieldDisable ? true : false}
                              />
                              {formError.NoOfSeats && (<div className="text-danger"> {formError.NoOfSeats} </div>)}
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className='col-lg-6 col-sm-6'>
                            <div className='row'>
                              <div className="col-lg-4 col-md-12 mb-1">
                                <label className="col-form-label">Active</label>
                              </div>
                              <div className="col-auto col-lg-8" disabled={false}>
                                <Switch
                                  onChange={handleisActive}
                                  checked={activeId}
                                  className="react-switch"
                                  disabled={fieldDisable ? true : false}
                                />
                              </div>
                              <ConfirmationModal
                                show={modalShow}
                                onHide={() => setModalShow(false)}
                                noconfirm={() => handleConfirmation(false)}
                                yesconfirm={() => handleConfirmation(true)}
                              />

                            </div>
                          </div>
                        </div>

                      </>
                      :
                      <>
                        <div className="col-lg-6 col-sm-6 ">
                          <div className="row">
                            <div className="col-lg-4 col-md-12 mb-1">
                              <label className="col-form-label required" htmlFor="VehicleName">Vehicle Name</label>
                            </div>
                            <div className="col-lg-8 mb-1 col-md-12">
                              <input
                                className="form-control"
                                type="text"
                                id="VehicleName"
                                name="VehicleName"
                                value={formValue.VehicleName}
                                onChange={(e) => handleChange(e.target.name, e.target.value)}
                                placeholder="Vehicle Name"
                                maxLength={100}
                                disabled={fieldDisable ? true : false}
                              />
                              {formError.VehicleName && (<div className="text-danger">{" "}{formError.VehicleName}{" "} </div>)}
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-6 col-sm-6 ">
                          <div className="row">
                            <div className="col-lg-4 col-md-12 mb-1">
                              <label className="col-form-label required">
                                Vehicle Category
                              </label>
                            </div>
                            <div className="col-lg-8 mb-1 col-md-12">
                              <Select
                                ref={selectCategoryId}
                                id="SelectCategoryId"
                                className="dropdown select_dropdown"
                                options={vehicleCategories}
                                value={vehicleCategories?.filter(function (category) {
                                  return category.value === SelectCategoryId;
                                })}
                                onChange={(e) => handleSelectCategoryChange(e)}
                                isDisabled={fieldDisable ? true : false}
                                isSearchable
                              />
                              {formError.selectCategoryId && (
                                <div className="text-danger">
                                  {" "}
                                  {formError.selectCategoryId}{" "}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-6 col-sm-6 ">
                          <div className="row">
                            <div className="col-lg-4 col-md-12 mb-1">
                              <label
                                className="col-form-label required"
                                htmlFor="SeatingCapacity"
                              >
                                Seating Capacity
                              </label>
                            </div>
                            <div className="col-lg-8 mb-1 col-md-12">
                              <input
                                className="form-control"
                                type="text"
                                id="SeatingCapacity"
                                name="SeatingCapacity"
                                value={formValue.SeatingCapacity === 0 ? '' : formValue.SeatingCapacity}
                                onChange={(e) => handleChange(e.target.name, Number(onlyNumeric(e.target.value)))}
                                placeholder="Seating Capacity"
                                maxLength={2}
                                disabled={fieldDisable ? true : false}
                              />
                              {formError.SeatingCapacity && (
                                <div className="text-danger">
                                  {" "}
                                  {formError.SeatingCapacity}{" "}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-6 col-sm-6 ">
                          <div className="row">
                            <div className="col-lg-4 col-md-12 mb-1">
                              <label className="col-form-label required">
                                Vehicle Type
                              </label>
                            </div>
                            <div className="col-lg-8 mb-1 col-md-12">
                              <Select
                                ref={vehicleTypeId}
                                id="VehicleTypeId"
                                className="dropdown select_dropdown"
                                options={vehicleTypeOption}
                                value={vehicleTypeOption?.filter(function (type) {
                                  return type.value === VehicleTypeId;
                                })}
                                onChange={(e) => handleVehicleTypeChange(e)}
                                isDisabled={fieldDisable ? true : false}
                                isSearchable
                              />
                              {formError.vehicleTypeId && (<div className="text-danger">{formError.vehicleTypeId}</div>)}
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-6 col-sm-6 ">
                          <div className="row">
                            <div className="col-lg-4 col-md-12 mb-1">
                              <label
                                className="col-form-label"
                                htmlFor="BaggageCapacity"
                              >
                                Baggage Capacity
                              </label>
                            </div>
                            <div className="col-lg-8 mb-1 col-md-12">
                              <input
                                className="form-control"
                                type="text"
                                id="BaggageCapacity"
                                name="BaggageCapacity"
                                value={formValue.BaggageCapacity === 0 ? '' : formValue.BaggageCapacity}
                                onChange={(e) => handleChange(e.target.name, Number(onlyNumeric(e.target.value)))}
                                placeholder="Baggage Capacity"
                                maxLength={3}
                                disabled={fieldDisable ? true : false}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="col-lg-6 col-sm-6">
                            <div className="row">
                              <div className="col-lg-4 col-md-12 mb-1">
                                <label className="col-form-label">Active</label>
                              </div>
                              <div className="col-auto col-lg-8" disabled={false}>
                                <Switch
                                  onChange={handleisActive}
                                  checked={activeId}
                                  className="react-switch"
                                  disabled={fieldDisable ? true : false}
                                />
                              </div>
                              <ConfirmationModal
                                show={modalShow}
                                onHide={() => setModalShow(false)}
                                noconfirm={() => handleConfirmation(false)}
                                yesconfirm={() => handleConfirmation(true)}
                              />
                            </div>
                          </div>
                        </div>
                      </>

                  }
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-center mb-4">
              {useradd === false && btntxt === "Add" ?
                (<button type="button" className="btn btn-primary mx-1" id="btnAdd" onClick={(e) => handleAdd(e)} disabled={!useradd}>{btntxt}</button>)
                :
                (<button type="button" className="btn btn-primary mx-1" id="btnAdd" onClick={(e) => handleAdd(e)} disabled={editdisabled ? false : true}>{btntxt}</button>)
              }
              <button type="button" className="btn btn-primary mx-1" id="btnClear" onClick={handleClear}>Clear</button>
            </div>

            <CommonFilter
              columns={columns}
              filterList={filterList}
              searchDisabled={searchDisabled}
              getdata={() => getvehiclelistdetails(vehicleoptionId)}
              setlistdata={setVehicleDataList}
              searchvalue={searchvalue}
              setSearchValue={setSearchValue}
              searchby={searchby}
              setSerachBy={setSerachBy}
            />

            <CustomTable
              columns={columns}
              data={vehicleDataList}
              PdfExport={PDFExport}
              ExportToExcel={ExcelExport}
              disabled={!userexport}
            />
          </form>
        </div>


      </div>
    </>
  );
}

export default Vehicalmaster;
